import type React from "react"

import { Box, Paper, Typography } from "@mui/material"

interface DataAlertBaseProps {
  altText?: string
  body: string
  img?: string
  title: string
}

const DataAlertBase: React.FC<DataAlertBaseProps> = ({
  altText,
  body,
  img,
  title,
}) => (
  <Paper
    sx={(theme) => ({
      backgroundColor: theme.palette.spectrum.blue[50],
      borderColor: theme.palette.spectrum.blue[400],
      width: theme.typography.pxToRem(376),
      p: 2,
    })}
    variant="outlined"
  >
    {img && (
      <Box
        alt={altText}
        component="img"
        src={img}
        sx={{ height: "57px", mb: 1 }}
      />
    )}
    <Typography
      component="h2"
      sx={{
        fontWeight: "bold",
        mb: 1,
      }}
    >
      {title}
    </Typography>
    <Typography sx={{ mb: 1 }} variant="body2">
      {body}
    </Typography>
  </Paper>
)

export default DataAlertBase
